import humanize from 'humanize-duration';
import { t } from 'i18next';

export const shortEnglishHumanizer = humanize.humanizer({
  language: 'shortEn',
  languages: {
    shortEn: {
      mo: (count) => (count === 1 ? t('month') : t('months')),
      d: (count) => (count === 1 ? t('day') : t('days')),
      h: (count) => (count === 1 ? t('hour') : t('hours')),
      m: () => t('mins'),
    },
  },
});
